import { useMemo } from 'react';
const DEFAULT_SIZE = { width: 0, height: 0, left: 0, top: 0 };
export default function useOffsets(tabs, tabSizes, holderScrollWidth) {
    return useMemo(() => {
        var _a, _b;
        const map = new Map();
        const lastOffset = tabSizes.get((_a = tabs[0]) === null || _a === void 0 ? void 0 : _a.key) || DEFAULT_SIZE;
        const rightOffset = lastOffset.left + lastOffset.width;
        for (let i = 0; i < tabs.length; i += 1) {
            const { key } = tabs[i];
            let data = tabSizes.get(key);
            // Reuse last one when not exist yet
            if (!data) {
                data = tabSizes.get((_b = tabs[i - 1]) === null || _b === void 0 ? void 0 : _b.key) || DEFAULT_SIZE;
            }
            const entity = (map.get(key) || Object.assign({}, data));
            // Right
            entity.right = rightOffset - entity.left - entity.width;
            // Update entity
            map.set(key, entity);
        }
        return map;
    }, [tabs.map(tab => tab.key).join('_'), tabSizes, holderScrollWidth]);
}
